import { Routes } from '@angular/router';
import { NotAuthGuard } from '@shared/guards/not-auth.guard';
import { RoutesPath } from '@shared/enums/routes-path';

export function commonRoutes(routesPath: {
  [key in RoutesPath]: string;
}): Routes {
  return [
    {
      path: routesPath.landings,
      loadComponent: () => import('@shared/pages/landings/landing.component').then((c) => c.LandingComponent),
    },
    {
      path: routesPath.dashboard,
      canActivate: [NotAuthGuard],
      loadChildren: () => import('@shared/pages/dashboard/dashboard.module').then((m) => m.DashboardModule),
    },
    {
      path: routesPath['payment-intent'],
      loadComponent: () =>
        import('@shared/pages/payment-intent/payment-intent.component').then((c) => c.PaymentIntentComponent),
    },
    {
      path: routesPath['payment-validation'],
      loadComponent: () =>
        import('@shared/pages/payment-validation/payment-validation.component').then(
          (c) => c.PaymentValidationComponent
        ),
    },
    {
      path: routesPath.preview,
      loadComponent: () => import('@shared/pages/preview/preview.component').then((c) => c.PreviewComponent),
    },

    {
      path: routesPath.loading,
      loadComponent: () => import('@shared/pages/loading/loading.component').then((c) => c.LoadingComponent),
    },
    {
      path: routesPath['loading-preview'],
      loadComponent: () =>
        import('@shared/pages/loading-preview/loading-preview.component').then((c) => c.LoadingPreviewComponent),
    },
    {
      path: routesPath['car-not-found'],
      loadComponent: () =>
        import('@shared/pages/car-not-found/car-not-found.component').then((c) => c.CarNotFoundComponent),
    },
    {
      path: routesPath.sso,
      loadComponent: () => import('@shared/pages/sso/sso.component').then((c) => c.SsoComponent),
    },
  ];
}
